import React from "react";
import Banner from "../components/home/banner";
import AOS from "aos";
import About from "../components/home/about";
import Counter from "../components/home/counter";
import Report from "../components/home/report";
import Services from "../components/home/services";
import Breaker from "../components/home/breaker";
import Products from "../components/home/products";
import Testimonials from "../components/home/testimonials";
import Partners from "../components/home/partners";
import { dealerDescription } from "../components/content/text";
import Becomedealer from "../components/home/becomeDealer";
import FashionSwiper from "../components/home/fashionSwiper";
const Home2 = () => {
  AOS.init({
    duration: 1200,
  });

  return (
    <div>
      <Banner />
      <About />
      <Counter />
      <Report
        title="Ready to"
        spantitle="Report a Maintenance Service?"
        tagline="Let's team up to turn this setback into a comeback!"
        downTagLine="Effortless Fixes, Trouble Free Updates!"
        btnTxt="FILE A SERVICE"
        para="Gear up for a seamless service journey with Extended Trust! If you're covered by our vehicle maintenance plan, swiftly complete the service report form. Our team is ready to orchestrate your car's speedy comeback because we believe in hassle free adventures on the road!"
      />
      <Services customClass="ltn__feature-area section-bg-1 pt-120 pb-90 mb-120---" />
      <Breaker />
      <Products />
      <Testimonials />
      <div className="mt-5 pt-5">
        <FashionSwiper />
      </div>
      <Partners />
      <Becomedealer dealerpara={dealerDescription} page={"/become-a-dealer"} />
    </div>
  );
};

export default Home2;
